import "../css/Contact.css";

const Contact = () => {
  return (
    <main className="contact">

      {/* HERO */}
      <section className="contact-hero">
        <h1>Contact</h1>
        <p>Come find us. We’re always here.</p>
      </section>

      {/* MAP */}
      <section className="contact-map">
        <iframe
          title="Neo Café Location"
          src="https://www.google.com/maps?q=coffee%20shop&output=embed"
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        />
      </section>

      {/* INFO */}
      <section className="contact-info">
        <div>
          <h3>Address</h3>
          <p>
            21 Brew Street<br />
            Downtown District<br />
            New York, NY
          </p>
        </div>

        <div>
          <h3>Hours</h3>
          <p>
            Monday – Sunday<br />
            8:00 AM – 11:00 PM
          </p>
        </div>

        <div>
          <h3>Contact</h3>
          <p>
            hello@neocafe.com<br />
            +1 (555) 234-9876
          </p>
        </div>
      </section>

      {/* FINAL TEXT */}
      <section className="contact-final">
        <p>
          Coffee tastes better<br />
          when shared in person.
        </p>
      </section>

    </main>
  );
};

export default Contact;
